import React from 'react';
import images from '../Assets/export.assets';
import {
  Box,
  Container,
} from './styles';

const COLOR = 10;

export default function Footer() {
  return (
    <Container>
      <Box>
        <div className="ftd-logo">
          <img
            src={images.logoFTD}
            alt="Logo da FTD Educação em azul"
          />
        </div>
        <div className="disclaimer">
          <p>Este material é destinado a educadores e familiares adultos.</p>
          <p>
            ©
            {' '}
            <i>Copyright</i>
            {' '}
            2024 - Centro Marista de Defesa da Infância - Todos os direitos reservados.
          </p>
        </div>
        <img
          src={images.logoFacaBonito}
          alt="Flor com pétalas amarelas"
        />
      </Box>
    </Container>
  );
}
